/**
 * T083: useCategories Hook
 * Query hook for fetching categories list
 */

import { useQuery } from '@tanstack/react-query'
import { listCategories } from '@/services/categories'
import { queryKeys } from '@/lib/query-keys'

export function useCategories() {
  return useQuery({
    queryKey: queryKeys.categories.all,
    queryFn: () => listCategories({ limit: 100 }),
  })
}
